import { render, staticRenderFns } from "./AlmanacPlusLogo.vue?vue&type=template&id=736b5b12&scoped=true"
import script from "./AlmanacPlusLogo.vue?vue&type=script&lang=ts&setup=true"
export * from "./AlmanacPlusLogo.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./AlmanacPlusLogo.vue?vue&type=style&index=0&id=736b5b12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736b5b12",
  null
  
)

export default component.exports